export enum MatchPeriod{
    T1 = "T1",
    T2 = "T2",
    T3 = "T3",
    T4 = "T4",
    PENALTIES = "PENALTIES"
}